import { ReactNode, useEffect, useRef } from "react";

import { autoSaveResources } from "../resources/middleware";
import { autoSaveThemes } from '../themes/middleware';
import { Button } from '../ui/components/Button';
import { Modal } from '../ui/components/Modal';

import { context, PluginContext } from "./context";
import { PluginContextType } from "./types";

import chromeStoreBadge from '../../../assets/ChromeWebStore_Badge_v2_340x96.png';

type Props = {
  children: ReactNode
}

export const PluginContextProvider = ({ children }: Props) => {

  const pluginRef = useRef<PluginContextType>(new PluginContext());

  useEffect(() => autoSaveResources(pluginRef.current), []);
  useEffect(() => autoSaveThemes(pluginRef.current), []);

  return (
    <context.Provider value={pluginRef.current}>
      {children}
    </context.Provider>
  );
};

const CHROME_STORE_URL = 'https://chromewebstore.google.com/detail/justwords-for-chrome/bncpjjjjagbmbmaefckmjecknmigphna';

export const PluginInstallRequestModal = () => {
  return (
    <Modal
      className='!justify-center'
      height={90}
      modalKey='pluginInstallRequest'
      width={75}
    >
      <h1 className='text-3xl my-8'>
        Install the JustWords Chrome extension to continue
      </h1>

      <div className='bg-white rounded-sm p-8 text-neutral-800 flex flex-col items-center justify-center shadow'>
        <p className='my-4'>
          You need to install the free { ' ' }
          <a
            className='text-jw-blue hover:text-jw-light-blue'
            href={CHROME_STORE_URL}
            target='_blank'
          >
            JustWords extension for Chrome
          </a>
          { ' ' } to use JustWords.
        </p>
        <a
          className='border rounded-sm hover:bg-jw-light-blue shadow-lg my-8'
          href={CHROME_STORE_URL}
          target='_blank'
        >
          <img
            alt='Available in the Chrome Web Store'
            src={chromeStoreBadge}
          />
        </a>
        <p className='my-4'>
          Once you have installed the extension:
        </p>
        <Button onClick={() => window.location.reload()}>
          Reload this page
        </Button>
      </div>
    </Modal>
  );
};
